'use strict';

import $ from 'jquery';
import {getLogger} from 'loglevel';
import config from '../../js/config';
import Analytics from '../Analytics/Analytics';

const log = getLogger('Video');

const YOUTUBE_IFRAME = '//www.youtube.com/embed/$1';
const YOUTUBE_PARAMS = 'fs=1&rel=0&modestbranding=1&iv_load_policy=3';
const VIMEO_IFRAME = '//player.vimeo.com/video/$1';
const VIMEO_PARAMS = 'title=0&byline=0&portrait=0';

const REGEX_VIMEO = /(?:http?s?:\/\/)?(?:www\.)?(?:vimeo\.com)\/?(.+)/g;
const REGEX_YOUTUBE = /(?:http?s?:\/\/)?(?:www\.)?(?:youtube\.com|youtu\.be)\/(?:watch\?v=|embed\/)?(.+)/g;


/**
 * A Video player using 3rd party iframe embeds
 *
 * Once the placeholder image is clicked, the 3rd party video iframe is embedded
 * Currently supports Youtube and Vimeo
 */
export default class IFrameVideoPlayer {
  constructor(el) {
    this.el = el;
    this.$el = $(el);
    this.hasPoster = this.$el.hasClass('IFrameVideoPlayer--poster');
    this.initialize();
  }

  initialize() {
    if (this.hasPoster) {
      this.$el.on('click', this.onPlay.bind(this));
    } else {
      this.embed();
    }
  }

  onPlay() {
    Analytics.push(config.analytics.events.click, config.analytics.categories.video, config.analytics.actions.play, this.getEmbedUrl());
    this.embed();
  }

  embed() {
    this.$el.addClass(config.classes.isActive);

    let url = this.getEmbedUrl(true);

    if (!url) {
      this.$el.addClass(config.classes.isInvalid);
      return;
    }

    if (this.hasPoster) {
      url += '&autoplay=1';
    }

    let $iFrame = $('<iframe>', {
      class: 'IFrameVideoPlayer-embed',
      src: url,
      width: '100%',
      height: '100%',
      frameborder: 0,
      allowfullscreen: true
    });

    if (this.hasPoster) {
      this.$el.find('.IFrameVideoPlayer-placeholder').after($iFrame);
    } else {
      this.$el.append($iFrame);
    }
  }

  getEmbedUrl(includeParams) {
    let videoId = this.$el.data('videoId');
    let videoType = this.$el.data('videoType');
    let videoUrl = this.$el.data('videoUrl');

    // Use the id and type if supplied
    if (videoId && videoType) {
      if (videoType === 'vimeo') {
        return this.replaceIframeId(VIMEO_IFRAME, videoId, (includeParams ? VIMEO_PARAMS : false));
      }

      if (videoType === 'youtube') {
        return this.replaceIframeId(YOUTUBE_IFRAME, videoId, (includeParams ? YOUTUBE_PARAMS : false));
      }
    }

    // Fallback to extracting from url
    if (videoUrl) {
      if (REGEX_VIMEO.test(videoUrl)) {
        return this.replaceUrlIframe(videoUrl, REGEX_VIMEO, VIMEO_IFRAME, (includeParams ? VIMEO_PARAMS : false));
      }

      if (REGEX_YOUTUBE.test(videoUrl)) {
        return this.replaceUrlIframe(videoUrl, REGEX_YOUTUBE, YOUTUBE_IFRAME, (includeParams ? YOUTUBE_PARAMS : false));
      }
    }

    // Could not find video
    log.error(`Video not found: id:${videoId} type:${videoType} url:${videoUrl}`);
    return false;
  }

  replaceIframeId(iframe, videoId, params) {
    iframe = iframe.replace('$1', videoId);

    if (params) {
      iframe += (iframe.indexOf('?') !== -1 ? '&' : '?') + params;
    }

    return iframe;
  }

  replaceUrlIframe(videoUrl, regex, iframe, params) {
    videoUrl = videoUrl.replace(regex, iframe);

    if (params) {
      videoUrl += (videoUrl.indexOf('?') !== -1 ? '&' : '?') + params;
    }

    return videoUrl;
  }
}


export function create($parent) {
  $parent.find('.IFrameVideoPlayer').each((n, el) => new IFrameVideoPlayer(el));
}



// WEBPACK FOOTER //
// ./assets/components/IFrameVideoPlayer/IFrameVideoPlayer.js